import { adminColumnDefinition, defaultColumnDefinition } from '../../../shared/columnDefinitions';
import { AdminCellRendererFactory } from '../../../shared/columnDefinitions/cellRenderers';

const rowIdComparator = (valueA, valueB) => Number(valueA) - Number(valueB);

const getColumnDefinitions = ({ onDeleteIconClick }) => {
  const AdminCellRenderer = AdminCellRendererFactory({
    shouldShowEditIcon: false,
    onDeleteIconClick,
  });

  return [
    {
      ...adminColumnDefinition,
      cellRenderer: AdminCellRenderer,
      rowDrag: true,
      width: 80,
      maxWidth: 80,
      sortable: false,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Error',
      field: 'error',
      colId: 'errorCol',
      width: 30,
      hide: true,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Row',
      field: 'rowId',
      width: 55,
      comparator: rowIdComparator,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Row Type',
      field: 'rowType',
      width: 100,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Category',
      field: 'categoryId',
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Account',
      field: 'accountId',
      width: 340,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Text',
      field: 'text',
      width: 400,
    },
  ];
};

export default getColumnDefinitions;
